import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Button,
  Checkbox,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
  PopoverAnchor,
  Flex,
  Card,
  CardBody,
  Grid,
  GridItem,
  Input,
  Text,
  Textarea,
  Select,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Stack,
  Radio,
  RadioGroup,
} from "@chakra-ui/react";
import {
  DocIcon,
  DocLargeIcon,
  DownloadIcon,
  AddButton,
} from "../../assets/svgs/Icons";
import SelectSearch from "react-select-search";
import { useDispatch, useSelector } from "react-redux";
import { getCompanyDetails } from "../../redux/company/CompanySlice";
import { unwrapResult } from "@reduxjs/toolkit";
import { TiDelete } from "react-icons/ti";
import {
  getAllHeaps,
  getInventory,
  getInventoryIds,
  getInventoryProc,
  getProductInfo,
  getHeapInventories,
  getProcess,
} from "../../api";
import { v4 as uuidv4 } from "uuid";
import { toast } from "react-toastify";
import { INPUT_INITIAL_VALUES, PRODUCT_INITIAL_VALUES } from "./TcForm";
import "./Tcform.css";
import * as Selector from "react-dropdown-select";
import dompurify from "dompurify";
import { MultiSelect } from "chakra-multiselect";

function TcFormCards2({
  productValues,
  setProductValues,
  productData,
  setProductData,
  productId,
  setProductId,
  selectedProductId,
  setSelectedProductId,
  productInfo,
  setProducts,
  products,
  setProductInfo,
  consumption,
  setConsumption,
  inputConsumption,
  setInputConsumption,
  certifiedWeight,
  setCertifiedWeight,
  inputValues,
  setInputValues,
  productClassifications,
  setProductClassifications,
  inventoryDetails,
  inputs,
  setInputs,
  setInventoryDetails,
  procNumbers,
  setProcNumbers,
  tc2error1,
  setTc2Error1,
  tc2error2,
  setTc2Error2,
  setTc2Error3,
  setTc2Error4,
  setTc2Error5,
  setTc2Error6,
  setTc2Error7,
  setTc2Error8,
  setTc2Error9,
  setTc2Error10,
  setTc2Error11,
  setTc2Error12,
  setTc2Error13,
  setTc2Error14,
  tc2error3,
  tc2error4,
  tc2error5,
  tc2error6,
  tc2error7,
  tc2error8,
  tc2error9,
  tc2error10,
  tc2error11,
  tc2error12,
  tc2error13,
  tc2error14,
  tc2error15,
  setTc2Error15,
  inventoryOptions,
  setInventoryOptions,
  topId,
  setTopId,
  setSelectedInvValue,
  selectedInvValue,
  selectedInventoryIds,
  setSelectedInventoryIds,
  filteredInventoryIds,
  setFilteredInventoryIds,
  currentClassificationId,
  setCurrentClassificationId,
  currentInventoryId,
  setCurrentInventoryId,
  unitId,
  heapNumbers,
  setHeapNumbers,
  heapId,
  setHeapId,
  processValues,
  selectedProductDetails,
  setSelectedProductDetails,
  ncConsumption,
  setNcConsumption,
  totalProductConsumption,
  setTotalProductConsumption,
  selectedProcessValue,
  setSelectedProcessValue,
  customProcessValue,
  setCustomProcessValue,
}) {
  const { userData } = useSelector((state) => state.auth);
  const { companyDetails } = useSelector((state) => state.company);
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedOptionInput, setSelectedOptionInput] = useState("procurement");
  const [resetFormFlag, setResetFormFlag] = useState(false);
  const [selectKey, setSelectKey] = useState(0);
  const [heapError, setHeapError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  // const addproducts = (productValues) => {
  //   if (productValues?.invoiceDate === "") {
  //     setTc2Error14(true);
  //     return toast.error("Invoice Date is required");
  //   }

  //   if (productValues?.process === "") {
  //     setTc2Error15(true);
  //     return toast.error("Process is required");
  //   }

  //   if (productValues?.netWeight === "") {
  //     setTc2Error9(true);
  //     return toast.error("Net weight is required");
  //   }

  //   if (productValues?.certifiedPercentage === "") {
  //     setTc2Error10(true);
  //     return toast.error("Percentage is required");
  //   }

  //   if (productValues?.certifiedLossPercentage === "") {
  //     setTc2Error11(true);
  //     return toast.error("Loss percentage is required");
  //   }

  //   if (
  //     parseFloat(productValues?.certifiedPercentage) >
  //       productInfo?.product_certifiedLabelGrade?.commodities[0]?.maxRange ||
  //     parseFloat(productValues?.certifiedPercentage) <= 0
  //   ) {
  //     setTc2Error6(true);
  //     return;
  //   }

  //   let totalNonCertifiedWeight = 0;

  //   productValues?.nonCertifiedMaterials?.forEach((material) => {
  //     if ("nonCertifiedWeight" in material) {
  //       totalNonCertifiedWeight += parseFloat(material?.nonCertifiedWeight);
  //     }
  //   });

  //   let totalWeight = certifiedWeight + totalNonCertifiedWeight;

  //   if (inputs.length <= 0) {
  //     return toast.info("Please add at least one input item before submitting");
  //   }

  //   if (totalWeight > parseFloat(productValues?.netWeight || 0)) {
  //     setTc2Error8(true);
  //     return toast.error(
  //       "The consumption weight does not match the total weight"
  //     );
  //   }

  //   let totalNonCertifiedConsumption = 0;

  //   productValues?.nonCertifiedMaterials?.forEach((material) => {
  //     if ("consumption" in material) {
  //       totalNonCertifiedConsumption += parseFloat(material?.consumption);
  //     }
  //   });

  //   //Previous calculation
  //   // let totalConsumption = consumption + totalNonCertifiedConsumption;
  //   let totalConsumption = consumption;

  //   // let totalInputsConsumption = inputConsumption;
  //   let totalInputsConsumption = 0; //fix by aarti triple check plsss verified by danish && gajju

  //   inputs?.forEach((input) => {
  //     if ("consumedQuantity" in input) {
  //       totalInputsConsumption += parseFloat(input?.consumedQuantity);
  //       totalInputsConsumption = parseFloat(totalInputsConsumption.toFixed(3));
  //     }
  //   });

  //   if (!(totalInputsConsumption === totalConsumption)) {
  //     setTc2Error5(true);
  //     return toast.error(
  //       `Total product consumption does not match total input consumption; net consumption remained to get added is ${(
  //         totalConsumption - totalInputsConsumption
  //       ).toFixed(3)} KG in input consumption`
  //     );
  //   }

  //   if (productId !== "") {
  //     setProductData([]);
  //     const productObject = {
  //       id: uuidv4(),
  //       productId: productId,
  //       productName: dompurify.sanitize(selectedProductId),
  //       productType: productInfo?.productType,
  //       productCategory: dompurify.sanitize(
  //         productInfo?.product_productCategory?.name
  //       ),
  //       process: dompurify.sanitize(productValues?.process),
  //       productClassification: dompurify.sanitize(
  //         productInfo?.product_productClassification?.name
  //       ),
  //       certifiedMaterialName: dompurify.sanitize(
  //         productInfo?.product_certifiedLabelGrade?.commodities?.map(
  //           (nestedCommodity) => nestedCommodity?.commodityId?.name
  //         )?.[0]
  //       ),
  //       invoiceNo: productValues.invoiceNo,
  //       invoiceDate: productValues.invoiceDate,
  //       lotNo: productValues?.lotNo,
  //       packedIn: dompurify.sanitize(productValues?.packedIn),
  //       certifiedMaterial: {
  //         commodityId:
  //           productInfo?.product_certifiedLabelGrade?.commodities?.map(
  //             (nestedCommodity) => nestedCommodity?.commodityId?._id
  //           )?.[0],
  //         percentage: parseFloat(productValues?.certifiedPercentage || 0),
  //         lossPercent: productValues.certifiedLossPercentage,
  //         consumption: consumption,
  //         certifiedWeight: certifiedWeight,
  //         maxVal:
  //           productInfo?.product_certifiedLabelGrade?.commodities[0]?.maxRange,
  //       },
  //       nonCertifiedMaterials: productValues.nonCertifiedMaterials,
  //       productInformation: dompurify.sanitize(
  //         productValues.productInformation
  //       ),
  //       grossWeight: productValues.grossWeight,
  //       certifiedWeight: certifiedWeight,
  //       netWeight: parseFloat(productValues?.netWeight || 0),
  //       inputs: inputs,
  //     };

  //     setProducts((products) => [productObject, ...products]);
  //     toast.success("Product added successfully");
  //     setProductValues(PRODUCT_INITIAL_VALUES);
  //     setProductId("");
  //     setInputValues(INPUT_INITIAL_VALUES);
  //     setInputs([]);
  //     getProductData();
  //     setProductInfo({});
  //     setSelectedInventoryIds([]);
  //     setTc2Error6(false);
  //     setTc2Error14(false);
  //     setTc2Error15(false);
  //     setInputConsumption(0);
  //   }
  // };

  const addproducts = (productValues) => {
    if (productValues?.invoiceDate === "") {
      setTc2Error14(true);
      return toast.error("Invoice Date is required");
    }

    if (customProcessValue?.length <= 0) {
      setTc2Error15(true);
      return toast.error("Process is required");
    }

    if (productValues?.netWeight === "") {
      setTc2Error9(true);
      return toast.error("Net weight is required");
    }

    if (productValues?.certifiedPercentage === "") {
      setTc2Error10(true);
      return toast.error("Percentage is required");
    }

    if (productValues?.certifiedLossPercentage === "") {
      setTc2Error11(true);
      return toast.error("Loss percentage is required");
    }

    if (
      parseFloat(productValues?.certifiedPercentage) >
        productInfo?.product_certifiedLabelGrade?.commodities[0]?.maxRange ||
      parseFloat(productValues?.certifiedPercentage) <= 0
    ) {
      setTc2Error6(true);
      return;
    }

    let totalNonCertifiedWeight = 0;

    productValues?.nonCertifiedMaterials?.forEach((material) => {
      if ("nonCertifiedWeight" in material) {
        totalNonCertifiedWeight += parseFloat(material?.nonCertifiedWeight);
      }
    });

    let totalWeight = certifiedWeight + totalNonCertifiedWeight;

    if (inputs.length <= 0) {
      return toast.info("Please add at least one input item before submitting");
    }

    // if (totalWeight > parseFloat(productValues?.netWeight || 0)) {
    //   setTc2Error8(true);
    //   return toast.error(
    //     "The consumption weight does not match the total weight"
    //   );
    // }

    let totalNonCertifiedConsumption = 0;

    productValues?.nonCertifiedMaterials?.forEach((material) => {
      if ("consumption" in material) {
        totalNonCertifiedConsumption += parseFloat(material?.consumption);
      }
    });

    let totalConsumption = consumption;
    let totalInputsConsumption = 0;

    inputs?.forEach((input) => {
      if ("consumedQuantity" in input) {
        totalInputsConsumption += parseFloat(input?.consumedQuantity);
        totalInputsConsumption = parseFloat(totalInputsConsumption.toFixed(3));
      }
    });

    let totalProductConsumption = parseFloat(
      (totalConsumption + totalNonCertifiedConsumption).toFixed(3) || 0
    );

    if (!(totalInputsConsumption === totalProductConsumption)) {
      setTc2Error5(true);
      return toast.error(
        `Total product consumption does not match total input consumption; net consumption remained to get added is ${(
          totalConsumption - totalInputsConsumption
        ).toFixed(3)} KG in input consumption`
      );
    }

    if (productId !== "") {
      setProductData([]);
      const sequenceNumber = products.length;

      const productObject = {
        id: uuidv4(),
        productId: productId,
        productName: dompurify.sanitize(selectedProductId),
        productType: productInfo?.productType,
        productCategory: dompurify.sanitize(
          productInfo?.product_productCategory?.name
        ),
        process: customProcessValue.map((values) => values.id),
        productClassification: dompurify.sanitize(
          productInfo?.product_productClassification?.name
        ),
        certifiedMaterialName: dompurify.sanitize(
          productInfo?.product_certifiedLabelGrade?.commodities?.map(
            (nestedCommodity) => nestedCommodity?.commodityId?.name
          )?.[0]
        ),
        invoiceNo: productValues.invoiceNo,
        invoiceDate: productValues.invoiceDate,
        lotNo: productValues?.lotNo,
        packedIn: dompurify.sanitize(productValues?.packedIn),
        certifiedMaterial: {
          commodityId:
            productInfo?.product_certifiedLabelGrade?.commodities?.map(
              (nestedCommodity) => nestedCommodity?.commodityId?._id
            )?.[0],
          percentage: parseFloat(productValues?.certifiedPercentage || 0),
          lossPercent: productValues.certifiedLossPercentage,
          consumption: consumption,
          certifiedWeight: certifiedWeight,
          maxVal:
            productInfo?.product_certifiedLabelGrade?.commodities[0]?.maxRange,
        },
        nonCertifiedMaterials: productValues.nonCertifiedMaterials,
        productInformation: dompurify.sanitize(
          productValues.productInformation
        ),
        grossWeight: productValues.grossWeight,
        certifiedWeight: certifiedWeight,
        netWeight: parseFloat(productValues?.netWeight || 0),
        inputs: inputs,
        sequenceNumber: sequenceNumber,
      };

      setProducts((products) => [productObject, ...products]);
      toast.success("Product added successfully");
      setProductValues(PRODUCT_INITIAL_VALUES);
      setProductId("");
      setInputValues(INPUT_INITIAL_VALUES);
      setInputs([]);
      getProductData();
      setProductInfo({});
      setSelectedInventoryIds([]);
      setTc2Error6(false);
      setTc2Error14(false);
      setTc2Error15(false);
      setInputConsumption(0);
      setCustomProcessValue([]);
      setSelectedProcessValue([]);
    }
  };

  const clearSelectedValue = () => {
    setSelectKey((prevKey) => prevKey + 1);
  };

  const getProcessName = (processId) => {
    return processValues.filter((process) => process.id === processId)?.[0]
      ?.value;
  };
  const getCompany = () => {
    try {
      const result = dispatch(getCompanyDetails(userData?.companyId));
      unwrapResult(result);
    } catch (error) {
      console.error(error.message);
    }
  };

  const getProductData = async () => {
    let productOPtions = companyDetails?.data?.company_products?.map(
      (product) => {
        return {
          name: `${product?.name}`,
          value: product?._id,
        };
      }
    );
    setProductData(productOPtions);
  };

  const getProductDetails = async () => {
    const response = await getProductInfo(productId);
    setProductInfo(response?.data);
  };

  useEffect(() => {
    getCompany();
    getProductData();
    getProductDetails();
  }, []);

  useEffect(() => {
    if (companyDetails) {
      getProductData();
    }
  }, [companyDetails]);

  useEffect(() => {
    if (productId) {
      getProductClassifications();
      getProductDetails();
    } else {
      setProductInfo({});
    }
  }, [productId]);

  const removeProductQuanity = (productId) => {
    let removedProduct;
    setProducts((prev) => {
      removedProduct = prev.find((product) => product._id === productId);
      return prev.filter((product) => product._id !== productId);
    });
    if (removedProduct) {
      setInventoryDetails((prev) =>
        prev.map((inventoryItem) => {
          let consumedQuantity = 0;
          removedProduct.inputs.forEach((inputItem) => {
            if (inputItem._id === inventoryItem._id) {
              consumedQuantity += inputItem.consumedQuantity;
            }
          });
          return {
            ...inventoryItem,
            remainingQuantity:
              inventoryItem.remainingQuantity + consumedQuantity,
          };
        })
      );
    }
  };

  const removeProducts = (id) => {
    removeProductQuanity(id);
    setProducts((prev) => prev.filter((product) => product.id !== id));
    toast.success("Product removed successfully");
  };

  const saveEditChanges = (selectedProductId) => {
    let productsCopy = [...products];
    const selectedProductIndex = productsCopy.findIndex(
      (product) => selectedProductId === productsCopy.id
    );
    productsCopy.splice(selectedProductIndex, 1, selectedProductId);
    setProducts([...productsCopy]);
    toast.success("Product Updated successflly");
  };

  const updateInput = (value, field, field2 = null, idx) => {
    const updatedProduct = [...products];
    const selectedProduct = updatedProduct[idx];
    if (field2) {
      selectedProduct[field][field2] = value;
    } else {
      selectedProduct[field] = value;
    }
    updatedProduct[idx] = selectedProduct;
    setProducts(updatedProduct);
  };

  const updateCertifiedInputs = (productIndex, key, e) => {
    const { name, value } = e.target;

    const productsA = [...products];
    let currentProduct = productsA[productIndex];
    if (key === "product") {
      currentProduct = { ...currentProduct, [name]: value };
    }
    let currentCompostion = {
      ...currentProduct.certifiedMaterial,
    };
    if (key === "composition") {
      currentCompostion = { ...currentCompostion, [name]: value };
    }
    let certifiedWeight = parseFloat(
      (currentProduct.netWeight * (currentCompostion.percentage / 100)).toFixed(
        3
      ) || 0
    );
    let consumption = parseFloat(
      ((certifiedWeight * 100) / (100 - currentCompostion.lossPercent)).toFixed(
        3
      ) || 0
    );

    currentCompostion.certifiedWeight = certifiedWeight;
    currentCompostion.consumption = consumption;

    currentProduct.certifiedMaterial = currentCompostion;
    productsA[productIndex] = currentProduct;
    setProducts(productsA);
  };

  const updateInputItem = (inputIndex, e) => {
    const { name, value } = e.target;

    const inputsA = [...inputs];
    let currentInput = inputsA[inputIndex];
    currentInput = { ...currentInput, [name]: value };

    inputsA[inputIndex] = currentInput;
    setInputs(inputsA);
  };

  const updateNcInput = (productIdx, ncIdx, e) => {
    let { name, value } = e.target;

    const productsA = [...products];

    let currentProduct = productsA[productIdx];

    let ncCompostion = [...currentProduct.nonCertifiedMaterials];

    let currentCompostion = {
      ...ncCompostion[ncIdx],
      [name]: value,
    };

    let nonCertifiedWeight = parseFloat(
      (
        currentProduct.netWeight *
        (currentCompostion?.percentage / 100)
      ).toFixed(3) || 0
    );

    let consumption = parseFloat(
      (
        (nonCertifiedWeight * 100) /
        (100 - currentCompostion?.lossPercent)
      ).toFixed(3) || 0
    );
    currentCompostion.nonCertifiedWeight = nonCertifiedWeight;
    currentCompostion.consumption = consumption;

    ncCompostion[ncIdx] = currentCompostion;

    currentProduct.nonCertifiedMaterials = ncCompostion;

    productsA[productIdx] = currentProduct;

    setProducts(productsA);
  };

  const handleNcInputChange = (e, index, commodityId, commodityName) => {
    let nonCertifiedWeight =
      productValues?.nonCertifiedMaterials[index]?.nonCertifiedWeight;
    let lossPercent = productValues?.nonCertifiedMaterials[index]?.lossPercent;

    if (e.target.name === "percentage") {
      nonCertifiedWeight = parseFloat(
        (productValues.netWeight * (e.target.value / 100)).toFixed(3) || 0
      );
    }

    let consumption =
      e.target.name === "lossPercent"
        ? parseFloat(
            ((nonCertifiedWeight * 100) / (100 - e.target.value)).toFixed(3) ||
              0
          )
        : parseFloat(
            ((nonCertifiedWeight * 100) / (100 - lossPercent)).toFixed(3) || 0
          );

    setProductValues((prevState) => {
      const newMaterials = [...prevState.nonCertifiedMaterials];
      newMaterials[index] = {
        ...newMaterials[index],
        commodityId: commodityId,
        commodityName: commodityName,
        [e.target.name]: parseFloat(e.target.value || 0),
        nonCertifiedWeight: nonCertifiedWeight,
        consumption: consumption,
      };

      return { ...prevState, nonCertifiedMaterials: newMaterials };
    });
  };

  const recalculateInputs = (e) => {
    const currentProduct = {
      ...productValues,
      netWeight: parseFloat(e.target.value),
    };
    let ncComposition = [...currentProduct.nonCertifiedMaterials];
    ncComposition = ncComposition.map((item) => {
      let nonCertifiedWeight = parseFloat(
        (currentProduct.netWeight * (item?.percentage / 100)).toFixed(3) || 0
      );

      let consumption = parseFloat(
        ((nonCertifiedWeight * 100) / (100 - item?.lossPercent)).toFixed(3) || 0
      );
      item.nonCertifiedWeight = nonCertifiedWeight;
      item.consumption = consumption;
      return item;
    });
    currentProduct.nonCertifiedMaterials = ncComposition;

    setProductValues(currentProduct);
  };

  const recalculateUpdatedInputs = (index, e) => {
    let productsA = [...products];
    const currentProduct = {
      ...productsA[index],
      netWeight: parseFloat(e.target.value),
    };
    let ncComposition = [...currentProduct.nonCertifiedMaterials];
    ncComposition = ncComposition.map((item) => {
      let nonCertifiedWeight = parseFloat(
        (currentProduct.netWeight * (item?.percentage / 100)).toFixed(3) || 0
      );

      let consumption = parseFloat(
        ((nonCertifiedWeight * 100) / (100 - item?.lossPercent)).toFixed(3) || 0
      );
      item.nonCertifiedWeight = nonCertifiedWeight;
      item.consumption = consumption;
      return item;
    });
    currentProduct.nonCertifiedMaterials = ncComposition;
    productsA[index] = currentProduct;
    setProducts(productsA);
  };

  // const getProductClassifications = async () => {
  //   const response = await getInventory(userData?.companyId);
  //   let unique = [];
  //   console.log(response)

  //   if (response) {
  //     const set = new Set();
  //     response?.data?.forEach((obj) => {
  //       if (!set.has(obj?.inventory_productClassification?._id)) {
  //         set.add(obj?.inventory_productClassification?._id);
  //         unique.push(obj?.inventory_productClassification);
  //       }
  //     });
  //   }
  //   setProductClassifications(unique);
  // };

  const getProductClassifications = async () => {
    setIsLoading(false);
    const response = await getInventory(userData?.companyId);
    const unique = [];
    const set = new Set();
    const isNcProductCompositionEmpty =
      !selectedProductDetails?.ncProductComposition?.length;

    if (response?.data?.length) {
      response.data.forEach(({ type, inventory_productClassification }) => {
        const productId = inventory_productClassification?._id;
        const shouldInclude =
          (isNcProductCompositionEmpty && type === "CERTIFIED") ||
          !isNcProductCompositionEmpty;

        if (shouldInclude && productId && !set.has(productId)) {
          set.add(productId);
          unique.push(inventory_productClassification);
        }
      });
    } else {
      console.warn("No inventory data available");
    }
    setIsLoading(true);

    setProductClassifications(unique);
  };

  const getInventoryDetails = async (topId, isHeap) => {
    if (topId) {
      let response;

      if (isHeap) {
        response = await getHeapInventories(topId);
      } else {
        response = await getInventoryIds(
          userData?.companyId,
          inputValues?.productClassificationId,
          topId
        );
      }

      let updatedResponse = response.data;
      if (products.length > 0) {
        updatedResponse = updatedResponse.map((inventoryItem) => {
          let consumedQuantity = 0;
          products?.forEach((product) => {
            product?.inputs?.forEach((inputItem) => {
              if (inputItem.inventoryDetails === inventoryItem._id) {
                consumedQuantity += inputItem.consumedQuantity;
              }
            });
          });
          return {
            ...inventoryItem,
            remainingQuantity:
              inventoryItem.remainingQuantity - consumedQuantity,
          };
        });
      }
      setInventoryDetails(updatedResponse);
    }
  };

  const getInventoryDetailsHeap = async () => {
    const response = await getAllHeaps();
    setHeapNumbers(response?.data);
  };

  const getInventoryDetailsProc = async (heapIdsToRemove) => {
    let currentClassificationId = inputValues?.productClassificationId;
    const response = await getInventoryProc(
      currentClassificationId,
      unitId,
      true,
      heapIdsToRemove
    );
    let updatedResponse;
    if (selectedInventoryIds?.length > 0) {
      updatedResponse = response?.data?.filter(
        (inventoryItem) => !selectedInventoryIds.includes(inventoryItem._id)
      );
      setFilteredInventoryIds(selectedInventoryIds);
    } else {
      updatedResponse = response?.data;
    }

    setProcNumbers(updatedResponse);
  };

  const getProductClassificationName = (productClassificationId) => {
    return productClassifications?.filter(
      (productClassification) =>
        productClassificationId === productClassification?._id
    )?.[0]?.name;
  };

  const removeInputs = (id, topId) => {
    if (topId) {
      setSelectedInventoryIds((prev) =>
        prev.filter((inventoryId) => inventoryId !== topId)
      );
    }
    setInputs((prev) => prev.filter((input) => input.inputId !== id));
    toast.success("Input removed successfully");
    const totalConsumedQuantity = inputs
      .filter((input) => input.inputId !== id)
      .reduce(
        (accumulator, input) =>
          accumulator + parseFloat(input.consumedQuantity),
        0
      )
      .toFixed(3);

    const updatedConsumption = consumption - totalConsumedQuantity;

    setInputConsumption(updatedConsumption);
  };

  const addInputs = (inputValues) => {
    if (
      productValues?.netWeight === "" ||
      productValues?.certifiedPercentage === "" ||
      productValues?.certifiedLossPercentage === ""
    ) {
      return toast.error(
        "Please fill all required product details before adding input"
      );
    }

    if (!topId) {
      setTc2Error13(true);
      return;
    }

    if (
      parseFloat(inputValues?.consumedQuantity || 0) === "" ||
      parseFloat(inputValues?.consumedQuantity || 0) <= 0
    ) {
      setTc2Error12(true);
      return;
    }

    if (
      parseFloat(inputValues?.consumedQuantity || 0) >
        inventoryDetails?.[0]?.remainingQuantity &&
      parseFloat(inputValues?.consumedQuantity || 0) > heapId?.totalQuantity
    ) {
      setTc2Error3(true);
      return;
    }
    setSelectedInventoryIds((prev) => [...prev, currentInventoryId]);

    if (
      !(
        parseFloat(inputValues?.consumedQuantity || 0) >
        inventoryDetails?.data?.[0]?.remainingQuantity
      ) &&
      !(parseFloat(inputValues?.consumedQuantity || 0) > heapId?.totalQuantity)
    ) {
      const inputObject = {
        inputId: uuidv4(),
        productClassification: inputValues?.productClassificationId
          ? inputValues?.productClassificationId
          : null,
        productClassificationName:
          getProductClassificationName(
            dompurify.sanitize(inputValues?.productClassificationId)
          ) || "",
        procurementId: procNumbers?.some(
          (details) => details?.inventory_procurement
        )
          ? topId
          : null,
        tcId: procNumbers?.some((details) => details?.inventory_tcDetails)
          ? topId
          : null,
        inventoryDetails:
          inventoryDetails?.[0]?._id || inputValues?.inventoryId,
        inventoryName: dompurify.sanitize(inventoryDetails?.[0]?.id),
        availableQuantity: heapId
          ? heapId?.totalQuantity
          : inventoryDetails?.[0]?.remainingQuantity,
        consumedQuantity: parseFloat(inputValues?.consumedQuantity || 0),
        heapId: inventoryDetails?.[0]?.heapId, //here is
        ...(heapId
          ? {
              heapId: heapId?._id,
              heapName: heapId?.number,
            }
          : {}),
      };

      setInputs((inputs) => [inputObject, ...inputs]);
      toast.success("Input item added successfully");
      setTopId("");
      clearSelectedValue();
      setInventoryOptions([]);
      setInventoryDetails([]);
      setInputValues(INPUT_INITIAL_VALUES);
      const totalConsumedQuantity = inputs
        .reduce(
          (accumulator, input) => accumulator + input.consumedQuantity,
          parseFloat(inputValues?.consumedQuantity || 0)
        )
        .toFixed(3);

      const updatedConsumption =
        totalProductConsumption - totalConsumedQuantity;

      setInputConsumption(updatedConsumption);
    }
  };

  const handleConsumedError = (currentInput, value) => {
    if (parseFloat(value || 0) > currentInput?.availableQuantity) {
      setTc2Error4(true);
    } else {
      setTc2Error4(false);
    }
  };

  // useEffect(() => {
  //   let certifiedWeight = parseFloat(
  //     (
  //       productValues.netWeight *
  //       (productValues.certifiedPercentage / 100)
  //     ).toFixed(3) || 0
  //   );
  //   setCertifiedWeight(certifiedWeight);

  //   let consumption = parseFloat(
  //     (
  //       (certifiedWeight * 100) /
  //       (100 - productValues.certifiedLossPercentage)
  //     ).toFixed(3) || 0
  //   );
  //   setConsumption(consumption);
  // }, [
  //   consumption,
  //   productValues.certifiedPercentage,
  //   productValues.netWeight,
  //   productValues.certifiedLossPercentage,
  // ]);

  useEffect(() => {
    // Calculate Certified Weight
    let certifiedWeight = parseFloat(
      (
        productValues.netWeight *
        (productValues.certifiedPercentage / 100)
      ).toFixed(3) || 0
    );
    setCertifiedWeight(certifiedWeight);

    let certifiedConsumption = parseFloat(
      (
        (certifiedWeight * 100) /
        (100 - productValues.certifiedLossPercentage)
      ).toFixed(3) || 0
    );

    setConsumption(certifiedConsumption);

    let totalNcConsumption = productValues.nonCertifiedMaterials.reduce(
      (acc, material) => acc + (material.consumption || 0),
      0
    );
    setNcConsumption(totalNcConsumption);

    let totalProductConsumption = parseFloat(
      (certifiedConsumption + totalNcConsumption).toFixed(3) || 0
    );
    setTotalProductConsumption(totalProductConsumption);

    setInputConsumption(totalProductConsumption);
  }, [
    productValues.certifiedPercentage,
    productValues.netWeight,
    productValues.certifiedLossPercentage,
    productValues.nonCertifiedMaterials,
  ]);

  useEffect(() => {
    getProductClassifications();
    getInventoryDetailsHeap();
  }, [selectedProductDetails]);

  useEffect(() => {
    const selectedProduct = companyDetails?.data?.company_products?.filter(
      (product) => product?._id === productId
    )?.[0];
    setSelectedProductId(selectedProduct?.name);
    setSelectedProductDetails(selectedProduct);
  }, [productId]);

  useEffect(() => {
    if (productId === "") {
      setTc2Error1(true);
    } else {
      setTc2Error1(false);
    }
  }, [productId]);

  useEffect(() => {
    let InventoryOptions =
      procNumbers &&
      procNumbers?.map((details, index) =>
        details?.inventory_procurement
          ? {
              value: `${details?.procurementId}`,
              label: `${details?.inventory_procurement?.id} - ${details?.inventory_procurement?.type} - ${details?.inventory_procurement?.stockQuantity?.netWeight} KG`,
              inventoryId: details?._id,
            }
          : {
              value: details?.tcId,
              label: `${details?.inventory_tcDetails?.tcNumber} - ${details?.inventory_tcDetails?.totalNetWeight} KG`,
              inventoryId: details?._id,
            }
      );

    setInventoryOptions(InventoryOptions);
  }, [procNumbers]);

  useEffect(() => {
    if (inputValues.productClassificationId === "") {
      setTc2Error2(true);
    } else {
      setTc2Error2(false);
    }
  }, [inputValues.productClassificationId]);

  const removeGivenHeapIdsFromInventoryOfProcurement = () => {
    //get heapId from product and add them to remove from inventories that has same heapID
    let heapIdsToRemove = [];
    inputs?.forEach((i) => {
      if (i?.heapId) {
        heapIdsToRemove.push(i?.heapId);
      }
    });
    getInventoryDetailsProc(heapIdsToRemove);
  };

  const removeGivenInventoryIdsFromInventoryOfHeap = () => {
    let selectedInventoryIds = [];
    inputs?.forEach((i) => {
      if (i?.heapId) {
        selectedInventoryIds.push(i?.heapId);
      }
    });
  };

  useEffect(() => {
    removeGivenInventoryIdsFromInventoryOfHeap();
  }, [inputs]);

  useEffect(() => {
    removeGivenHeapIdsFromInventoryOfProcurement();
  }, [inputValues?.productClassificationId, inputs]);

  return (
    <>
      <Box bg="#FFFFFF" padding={"2rem"} marginTop="2rem" borderRadius={"15px"}>
        <Grid
          width={"100%"}
          templateColumns="repeat(1, 1fr)"
          my={"1rem"}
          gap="3rem"
          paddingLeft={"2rem"}
        ></Grid>
        <Accordion defaultIndex={[0]}>
          <AccordionItem>
            <Box display={"flex"} justifyContent="space-between">
              <AccordionButton
                _expanded={{
                  bg: "linear-gradient(90deg, rgba(81,187,255,1) 0%, rgba(81,187,255,1) 15%, rgba(164,206,255,1) 100%)",
                  color: "#fff",
                  borderTopRightRadius: "100px",
                  borderBottomRightRadius: "80px 80px",
                }}
              >
                <Box
                  as="span"
                  borderRight={"3px solid #2272D5"}
                  height="40px"
                  marginRight={"1rem"}
                ></Box>
                <Text fontSize="lg" fontWeight={"800"}>
                  Fill Product and Input Details &nbsp;{" "}
                  <AddButton width="8" height="8" />
                </Text>
                <AccordionIcon ml={"10px"} />
              </AccordionButton>
            </Box>
            <AccordionPanel pb={4}>
              <Flex
                justifyContent={"center"}
                gap="2rem"
                fontWeight={"bold"}
                py="1rem"
              >
                {/* <Text>
                  Total product consumption: {consumption?.toFixed(3)} KG
                </Text> */}
                <Box>
                  <Text>
                    Certified Product Consumption: {consumption?.toFixed(3)} KG
                  </Text>
                  <Text>
                    Non-Certified Product Consumption:{" "}
                    {ncConsumption?.toFixed(3)} KG
                  </Text>
                  <Text>
                    Total Product Consumption:{" "}
                    {(consumption + ncConsumption).toFixed(3)} KG
                  </Text>
                </Box>
                <Text
                  borderLeft={{ base: "", md: "", lg: "1px solid #52BBFF" }}
                  paddingLeft={{ base: "", md: "", lg: "1rem" }}
                >
                  Total input consumption: {inputConsumption?.toFixed(3)} KG to
                  be added to match the total product consumption
                </Text>
              </Flex>
              <Grid
                templateColumns={{
                  base: "1fr",
                  md: "1fr",
                  xl: "repeat(2, 1fr)",
                }}
                gap="1rem"
              >
                <GridItem>
                  <Box bg="#FFFFFF" padding={"2rem"} borderRadius={"15px"}>
                    <Box paddingLeft={"3rem"}>
                      <Box>
                        <Grid
                          templateColumns={"repeat(2, 1fr)"}
                          // my={"1rem"}
                          gap="1rem"
                        >
                          <GridItem>
                            <Text
                              color={"#141D43"}
                              fontSize="md"
                              fontWeight={"700"}
                              fontFamily={"font.roboto"}
                              marginBottom={"10px"}
                            >
                              Product &nbsp;
                              <Text as="span" color="red">
                                *
                              </Text>
                            </Text>

                            <SelectSearch
                              options={productData}
                              value={productData?._id}
                              search
                              onChange={(e) => {
                                setProductId(e);
                                setTc2Error1(false);
                              }}
                              placeholder="Search and add Product"
                            />
                          </GridItem>
                          {/* <GridItem pr="2rem">
                            <Text
                              color={"#141D43"}
                              fontSize="md"
                              fontWeight={"700"}
                              fontFamily={"font.roboto"}
                            >
                              Product Type
                            </Text>

                            <Input
                              color={"#141D43"}
                              marginTop="10px"
                              border="2px solid  #8fd0fd !important"
                              w="100%"
                              value={
                                productInfo?.productType
                                  ? productInfo?.productType
                                  : ""
                              }
                              disabled
                              opacity={"1 !important"}
                              fontSize={"14px"}
                              _placeholder={{
                                opacity: 1,
                                color: "#141D43",
                                fontSize: "14px",
                              }}
                            />
                          </GridItem> */}
                          <GridItem pr="2rem">
                            <Text
                              color={"#141D43"}
                              fontSize="md"
                              fontWeight={"700"}
                              fontFamily={"font.roboto"}
                            >
                              Process&nbsp;
                              <Text as="span" color="red">
                                *
                              </Text>
                            </Text>

                            {/* <Select
                              color={"#141D43"}
                              marginTop="10px"
                              border="2px solid  #8fd0fd !important"
                              w="100%"
                              onChange={(e) => {
                                setProductValues({
                                  ...productValues,
                                  process: e.target.value,
                                });
                              }}
                              value={productValues?.process}
                              opacity={"1 !important"}
                              fontSize={"14px"}
                              _placeholder={{
                                opacity: 1,
                                color: "#141D43",
                                fontSize: "14px",
                              }}
                            >
                              <option value="">Select Process</option>
                              {processValues?.map((process) => (
                                <option value={process?.id}>
                                  {process?.value}
                                </option>
                              ))}
                            </Select> */}
                            <MultiSelect
                              marginTop={"10px"}
                              options={processValues}
                              value={selectedProcessValue}
                              placeholder="Select Processes"
                              border="2px solid  #8fd0fd !important"
                              onChange={(value) => {
                                const newArr = value.map(
                                  (value) =>
                                    processValues.filter(
                                      (process) => process.label === value
                                    )[0]
                                );
                                setCustomProcessValue(newArr);
                                setSelectedProcessValue(value);
                              }}
                            />
                          </GridItem>
                        </Grid>
                        <Grid
                          templateColumns={"repeat(2, 1fr)"}
                          gap="1rem"
                          mt="1rem"
                        >
                          <GridItem>
                            <Text
                              color={"#141D43"}
                              fontSize="md"
                              fontWeight={"700"}
                              fontFamily={"font.roboto"}
                            >
                              Invoice No.
                            </Text>
                            <Input
                              color={"#141D43"}
                              marginTop="10px"
                              border="2px solid  #8fd0fd !important"
                              w="100%"
                              bg={"#fff"}
                              value={productValues.invoiceNo}
                              onChange={(e) => {
                                setProductValues({
                                  ...productValues,
                                  invoiceNo: e.target.value,
                                });
                              }}
                              fontSize={"14px"}
                              _placeholder={{
                                opacity: 1,
                                color: "#141D43",
                                fontSize: "14px",
                              }}
                            />
                          </GridItem>
                          <GridItem>
                            <Text
                              color={"#141D43"}
                              fontSize="md"
                              fontWeight={"700"}
                              fontFamily={"font.roboto"}
                            >
                              Invoice Date &nbsp;
                              <Text as="span" color="red">
                                *
                              </Text>
                            </Text>
                            <Input
                              type="date"
                              color={"#141D43"}
                              marginTop="10px"
                              border="2px solid  #8fd0fd !important"
                              w="100%"
                              bg={"#fff"}
                              value={productValues.invoiceDate}
                              onChange={(e) => {
                                setProductValues({
                                  ...productValues,
                                  invoiceDate: e.target.value,
                                });
                              }}
                              fontSize={"14px"}
                              _placeholder={{
                                opacity: 1,
                                color: "#141D43",
                                fontSize: "14px",
                              }}
                            />
                          </GridItem>
                        </Grid>
                        <Grid
                          templateColumns={"repeat(2, 1fr)"}
                          gap="1rem"
                          mt="1rem"
                        >
                          <GridItem>
                            <Text
                              color={"#141D43"}
                              fontSize="md"
                              fontWeight={"700"}
                              fontFamily={"font.roboto"}
                            >
                              Lot No.
                            </Text>
                            <Input
                              color={"#141D43"}
                              marginTop="10px"
                              border="2px solid  #8fd0fd !important"
                              w="100%"
                              bg={"#fff"}
                              value={productValues.lotNo}
                              onChange={(e) => {
                                setProductValues({
                                  ...productValues,
                                  lotNo: e.target.value,
                                });
                              }}
                              fontSize={"14px"}
                              _placeholder={{
                                opacity: 1,
                                color: "#141D43",
                                fontSize: "14px",
                              }}
                            />
                          </GridItem>
                          <GridItem>
                            <Text
                              color={"#141D43"}
                              fontSize="md"
                              fontWeight={"700"}
                              fontFamily={"font.roboto"}
                            >
                              Packed In
                            </Text>
                            <Input
                              color={"#141D43"}
                              marginTop="10px"
                              border="2px solid  #8fd0fd !important"
                              w="100%"
                              bg={"#fff"}
                              value={productValues.packedIn}
                              onChange={(e) => {
                                setProductValues({
                                  ...productValues,
                                  packedIn: e.target.value,
                                });
                              }}
                              fontSize={"14px"}
                              _placeholder={{
                                opacity: 1,
                                color: "#141D43",
                                fontSize: "14px",
                              }}
                            />
                          </GridItem>
                        </Grid>
                        <Grid
                          templateColumns="repeat(2,1fr)"
                          gap="1rem"
                          mt={"1rem"}
                        >
                          <GridItem>
                            <Text
                              color={"#141D43"}
                              fontSize="md"
                              fontWeight={"700"}
                              fontFamily={"font.roboto"}
                            >
                              Net Weight (kg){" "}
                              <Text as="span" color="red">
                                *
                              </Text>
                            </Text>
                            <Input
                              color={"#141D43"}
                              marginTop="10px"
                              type="number"
                              border="2px solid  #8fd0fd !important"
                              w="100%"
                              bg={"#fff"}
                              fontSize={"14px"}
                              value={productValues.netWeight}
                              _focusVisible={
                                tc2error9
                                  ? {
                                      border: "1px solid red",
                                    }
                                  : { border: "1px solid #464C64" }
                              }
                              onChange={(e) => {
                                // setProductValues({
                                //   ...productValues,
                                //   netWeight: e.target.value,
                                // });
                                recalculateInputs(e);
                                setTc2Error9(false);
                              }}
                              _placeholder={{
                                opacity: 1,
                                color: "#141D43",
                                fontSize: "14px",
                              }}
                            />
                            {tc2error9 && (
                              <Box
                                className="error-message"
                                color={"red"}
                                mt="1rem"
                              >
                                Net Weight is required
                              </Box>
                            )}
                          </GridItem>
                          <GridItem>
                            <Text
                              color={"#141D43"}
                              fontSize="md"
                              fontWeight={"700"}
                              fontFamily={"font.roboto"}
                            >
                              Gross Weight (kg)
                            </Text>
                            <Input
                              color={"#141D43"}
                              marginTop="10px"
                              type="number"
                              border="2px solid  #8fd0fd !important"
                              w="100%"
                              bg={"#fff"}
                              value={productValues.grossWeight}
                              onChange={(e) => {
                                setProductValues({
                                  ...productValues,
                                  grossWeight: e.target.value,
                                });
                              }}
                              fontSize={"14px"}
                              _placeholder={{
                                opacity: 1,
                                color: "#141D43",
                                fontSize: "14px",
                              }}
                            />
                          </GridItem>
                        </Grid>
                        <Grid
                          templateColumns="repeat(2, 1fr)"
                          gap={"1rem"}
                          mt="1rem"
                        >
                          <GridItem>
                            <Text
                              color={"#141D43"}
                              fontSize="md"
                              fontWeight={"700"}
                              fontFamily={"font.roboto"}
                            >
                              Product Category
                            </Text>

                            <Input
                              color={"#141D43"}
                              marginTop="10px"
                              border="2px solid  #8fd0fd !important"
                              w="100%"
                              value={
                                productInfo?.product_productCategory?.name
                                  ? productInfo?.product_productCategory?.name
                                  : ""
                              }
                              disabled
                              opacity={"1 !important"}
                              fontSize={"14px"}
                              _placeholder={{
                                opacity: 1,
                                color: "#141D43",
                                fontSize: "14px",
                              }}
                            />
                          </GridItem>
                          <GridItem>
                            <Text
                              color={"#141D43"}
                              fontSize="md"
                              fontWeight={"700"}
                              fontFamily={"font.roboto"}
                            >
                              Product Classification
                            </Text>
                            <Input
                              color={"#141D43"}
                              marginTop="10px"
                              border="2px solid  #8fd0fd !important"
                              w="100%"
                              value={
                                productInfo?.product_productClassification?.name
                                  ? productInfo?.product_productClassification
                                      ?.name
                                  : ""
                              }
                              disabled
                              opacity={"1 !important"}
                              fontSize={"14px"}
                              _placeholder={{
                                opacity: 1,
                                color: "#141D43",
                                fontSize: "14px",
                              }}
                            />
                          </GridItem>
                        </Grid>
                        <Grid
                          templateColumns="repeat(1,1fr)"
                          mt="1rem"
                          gap={"3rem"}
                        >
                          <GridItem>
                            <Grid templateColumns="repeat(2,2fr)" gap="1rem">
                              <GridItem>
                                <Text
                                  color={"#141D43"}
                                  fontSize="md"
                                  fontWeight={"700"}
                                  fontFamily={"font.roboto"}
                                >
                                  Certified Material
                                </Text>
                                <Input
                                  color={"#141D43"}
                                  marginTop="10px"
                                  border="2px solid  #8fd0fd !important"
                                  w="100%"
                                  value={
                                    productInfo?.product_certifiedLabelGrade?.commodities?.map(
                                      (nestedCommodity) =>
                                        nestedCommodity?.commodityId?.name
                                    )?.[0]
                                      ? productInfo?.product_certifiedLabelGrade?.commodities?.map(
                                          (nestedCommodity) =>
                                            nestedCommodity?.commodityId?.name
                                        )?.[0]
                                      : ""
                                  }
                                  disabled
                                  opacity={"1 !important"}
                                  fontSize={"14px"}
                                  _placeholder={{
                                    opacity: 1,
                                    color: "#141D43",
                                    fontSize: "14px",
                                  }}
                                />
                              </GridItem>
                              <GridItem>
                                <Box
                                  display={"flex"}
                                  justifyContent={"center"}
                                  alignItems={"center"}
                                >
                                  <Box>
                                    <Text
                                      color={"#141D43"}
                                      fontSize="sm"
                                      fontWeight={"700"}
                                      fontFamily={"font.roboto"}
                                    >
                                      Percentage{" "}
                                      <Text as="span" color="red">
                                        *
                                      </Text>
                                    </Text>
                                    <Input
                                      color={"#141D43"}
                                      marginTop="10px"
                                      type="number"
                                      border="2px solid  #8fd0fd !important"
                                      position={"relative"}
                                      w="50%"
                                      bg={"#fff"}
                                      value={productValues.certifiedPercentage}
                                      onChange={(e) => {
                                        setProductValues({
                                          ...productValues,
                                          certifiedPercentage: e.target.value,
                                        });
                                        if (
                                          !(
                                            parseFloat(
                                              productValues?.certifiedPercentage
                                            ) >
                                            productInfo
                                              ?.product_certifiedLabelGrade
                                              ?.commodities[0]?.maxRange
                                          )
                                        ) {
                                          setTc2Error6(false);
                                        }
                                        setTc2Error10(false);
                                      }}
                                      _focusVisible={
                                        tc2error6 || tc2error10
                                          ? {
                                              border:
                                                "1px solid red !important",
                                            }
                                          : { border: "1px solid #8fd0fd " }
                                      }
                                      fontSize={"14px"}
                                      _placeholder={{
                                        opacity: 1,
                                        color: "#141D43",
                                        fontSize: "14px",
                                      }}
                                    />
                                    {tc2error6 && (
                                      <Box
                                        className="error-message"
                                        position={"absolute"}
                                        fontSize={"14px"}
                                        width={"220px"}
                                        color={"red"}
                                        mt="1rem"
                                      >
                                        {parseFloat(
                                          productValues?.certifiedPercentage
                                        ) <= 0 ? (
                                          "Percentage should be greater than 0"
                                        ) : (
                                          <Box>
                                            Percentage can't be greater
                                            certified material max range{" "}
                                            <Box as="span" fontWeight={"800"}>
                                              {
                                                productInfo
                                                  ?.product_certifiedLabelGrade
                                                  ?.commodities[0]?.maxRange
                                              }{" "}
                                              %
                                            </Box>
                                          </Box>
                                        )}
                                      </Box>
                                    )}
                                  </Box>
                                  <Box>
                                    <Text
                                      color={"#141D43"}
                                      fontSize="sm"
                                      fontWeight={"700"}
                                      fontFamily={"font.roboto"}
                                    >
                                      Loss Percent
                                      <Text as="span" color="red">
                                        *
                                      </Text>
                                    </Text>
                                    <Input
                                      color={"#141D43"}
                                      marginTop="10px"
                                      type="number"
                                      position={"relative"}
                                      border="2px solid  #8fd0fd !important"
                                      w="50%"
                                      bg={"#fff"}
                                      value={
                                        productValues.certifiedLossPercentage
                                      }
                                      _focusVisible={
                                        tc2error11
                                          ? {
                                              border:
                                                "1px solid red !important",
                                            }
                                          : { border: "1px solid #8fd0fd " }
                                      }
                                      onChange={(e) => {
                                        setProductValues({
                                          ...productValues,
                                          certifiedLossPercentage:
                                            e.target.value,
                                        });
                                        setTc2Error11(false);
                                      }}
                                      fontSize={"14px"}
                                      _placeholder={{
                                        opacity: 1,
                                        color: "#141D43",
                                        fontSize: "14px",
                                      }}
                                    />
                                  </Box>
                                </Box>
                              </GridItem>
                            </Grid>
                            <Grid
                              templateColumns="repeat(2,1fr)"
                              gap="1rem"
                              mt={tc2error6 ? "5rem" : "1rem"}
                            >
                              <GridItem>
                                <Text
                                  color={"#141D43"}
                                  fontSize="md"
                                  fontWeight={"700"}
                                  fontFamily={"font.roboto"}
                                >
                                  Certified Weight (kg)
                                </Text>
                                <Input
                                  color={"#141D43"}
                                  marginTop="10px"
                                  border="2px solid  #8fd0fd !important"
                                  w="100%"
                                  bg={"#fff"}
                                  value={certifiedWeight ? certifiedWeight : ""}
                                  disabled
                                  opacity={"1 !important"}
                                  fontSize={"14px"}
                                  _placeholder={{
                                    opacity: 1,
                                    color: "#141D43",
                                    fontSize: "14px",
                                  }}
                                />
                              </GridItem>
                              <GridItem>
                                <Text
                                  color={"#141D43"}
                                  fontSize="md"
                                  fontWeight={"700"}
                                  fontFamily={"font.roboto"}
                                >
                                  Consumption (kg)
                                </Text>
                                <Input
                                  color={"#141D43"}
                                  marginTop="10px"
                                  border="2px solid  #8fd0fd !important"
                                  w="100%"
                                  bg={"#fff"}
                                  fontSize={"14px"}
                                  value={consumption ? consumption : ""}
                                  disabled
                                  opacity={"1 !important"}
                                  _placeholder={{
                                    opacity: 1,
                                    color: "#141D43",
                                    fontSize: "14px",
                                  }}
                                />
                              </GridItem>
                            </Grid>
                            <Grid templateColumns="repeat(1, 1fr)" mt="1rem">
                              <GridItem>
                                <Text
                                  color={"#141D43"}
                                  fontSize="md"
                                  fontWeight={"700"}
                                  fontFamily={"font.roboto"}
                                >
                                  Product Information
                                </Text>
                                <Textarea
                                  type="text"
                                  color={"#141D43"}
                                  marginTop="1rem"
                                  bg={"#fff"}
                                  h={"100%"}
                                  w={"100%"}
                                  border="2px solid  #8fd0fd !important"
                                  placeholder="Remarks"
                                  value={productValues.productInformation}
                                  onChange={(e) => {
                                    setProductValues({
                                      ...productValues,
                                      productInformation: e.target.value,
                                    });
                                  }}
                                  fontSize={"14px"}
                                  _placeholder={{
                                    opacity: 1,
                                    color: " #464C64",
                                    fontSize: "14px",
                                  }}
                                />
                              </GridItem>
                            </Grid>
                            <Box
                              marginTop="1rem"
                              border={"1px solid #52BBFF"}
                              width="100%"
                              marginBottom={"3rem"}
                            ></Box>
                            {productInfo?.ncProductComposition?.length > 0 ? (
                              <>
                                <Text
                                  color={"#141D43"}
                                  fontSize="md"
                                  fontWeight={"700"}
                                  marginTop={"1rem"}
                                  fontFamily={"font.roboto"}
                                >
                                  Non Certified Materials
                                </Text>
                                <Box
                                  border={"2px solid #2272D5"}
                                  width="10%"
                                  marginBottom={"1rem"}
                                ></Box>{" "}
                              </>
                            ) : (
                              ""
                            )}

                            <Accordion defaultIndex={[0]}>
                              {productInfo?.ncProductComposition
                                ? productInfo?.ncProductComposition?.map(
                                    (data, index) => (
                                      <AccordionItem>
                                        <h2>
                                          <AccordionButton>
                                            <Box
                                              as="span"
                                              flex="1"
                                              textAlign="left"
                                            >
                                              <Text
                                                color={"#141D43"}
                                                fontSize="md"
                                                fontWeight={"700"}
                                                fontFamily={"font.roboto"}
                                              >
                                                {data?.commodity?.name
                                                  ? data?.commodity?.name
                                                  : "N/A"}
                                              </Text>
                                            </Box>
                                            <AccordionIcon />
                                          </AccordionButton>
                                        </h2>
                                        <AccordionPanel pb={4}>
                                          <Box marginBottom={"1rem"}>
                                            <Grid
                                              templateColumns="repeat(2,2fr)"
                                              gap="1rem"
                                            >
                                              <GridItem>
                                                <Box>
                                                  <Text
                                                    color={"#141D43"}
                                                    fontSize="sm"
                                                    fontWeight={"700"}
                                                    fontFamily={"font.roboto"}
                                                  >
                                                    Percentage
                                                  </Text>
                                                  <Input
                                                    color={"#141D43"}
                                                    marginTop="10px"
                                                    border="2px solid  #8fd0fd !important"
                                                    w="100%"
                                                    type="number"
                                                    name="percentage"
                                                    bg={"#fff"}
                                                    value={
                                                      productValues
                                                        .nonCertifiedMaterials[
                                                        index
                                                      ]?.percentage || ""
                                                    }
                                                    onChange={(e) =>
                                                      handleNcInputChange(
                                                        e,
                                                        index,
                                                        data.commodity?._id,
                                                        data.commodity?.name
                                                      )
                                                    }
                                                    fontSize={"14px"}
                                                    _placeholder={{
                                                      opacity: 1,
                                                      color: "#141D43",
                                                      fontSize: "14px",
                                                    }}
                                                  />
                                                </Box>
                                              </GridItem>
                                              <GridItem>
                                                <Box>
                                                  <Text
                                                    color={"#141D43"}
                                                    fontSize="sm"
                                                    fontWeight={"700"}
                                                    fontFamily={"font.roboto"}
                                                  >
                                                    Loss Percent
                                                  </Text>
                                                  <Input
                                                    color={"#141D43"}
                                                    marginTop="10px"
                                                    border="2px solid  #8fd0fd !important"
                                                    w="100%"
                                                    name="lossPercent"
                                                    bg={"#fff"}
                                                    value={
                                                      productValues
                                                        .nonCertifiedMaterials[
                                                        index
                                                      ]?.lossPercent || ""
                                                    }
                                                    onChange={(e) =>
                                                      handleNcInputChange(
                                                        e,
                                                        index,
                                                        data.commodity?._id,
                                                        data.commodity?.name
                                                      )
                                                    }
                                                    fontSize={"14px"}
                                                    _placeholder={{
                                                      opacity: 1,
                                                      color: "#141D43",
                                                      fontSize: "14px",
                                                    }}
                                                  />
                                                </Box>
                                              </GridItem>
                                            </Grid>
                                            <Grid
                                              templateColumns="repeat(2,1fr)"
                                              gap="1rem"
                                              mt={"1rem"}
                                            >
                                              <GridItem>
                                                <Text
                                                  color={"#141D43"}
                                                  fontSize="md"
                                                  fontWeight={"700"}
                                                  fontFamily={"font.roboto"}
                                                >
                                                  Consumption
                                                </Text>
                                                <Input
                                                  color={"#141D43"}
                                                  marginTop="10px"
                                                  border="2px solid  #8fd0fd !important"
                                                  w="100%"
                                                  bg={"#fff"}
                                                  value={
                                                    productValues
                                                      .nonCertifiedMaterials[
                                                      index
                                                    ]?.consumption || ""
                                                  }
                                                  disabled
                                                  opacity={"1 !important"}
                                                  fontSize={"14px"}
                                                  _placeholder={{
                                                    opacity: 1,
                                                    color: "#141D43",
                                                    fontSize: "14px",
                                                  }}
                                                />
                                              </GridItem>
                                              <GridItem>
                                                <Text
                                                  color={"#141D43"}
                                                  fontSize="md"
                                                  fontWeight={"700"}
                                                  fontFamily={"font.roboto"}
                                                >
                                                  Weight
                                                </Text>
                                                <Input
                                                  color={"#141D43"}
                                                  marginTop="10px"
                                                  border="2px solid  #8fd0fd !important"
                                                  w="100%"
                                                  bg={"#fff"}
                                                  value={
                                                    productValues
                                                      .nonCertifiedMaterials[
                                                      index
                                                    ]?.nonCertifiedWeight || ""
                                                  }
                                                  disabled
                                                  opacity={"1 !important"}
                                                  fontSize={"14px"}
                                                  _placeholder={{
                                                    opacity: 1,
                                                    color: "#141D43",
                                                    fontSize: "14px",
                                                  }}
                                                />
                                              </GridItem>
                                            </Grid>
                                          </Box>
                                        </AccordionPanel>
                                      </AccordionItem>
                                    )
                                  )
                                : // <Text
                                  //   fontSize="md"
                                  //   fontWeight={"700"}
                                  //   marginTop={"1rem"}
                                  //   fontFamily={"font.roboto"}
                                  // >
                                  //   N/A
                                  // </Text>
                                  ""}
                            </Accordion>
                          </GridItem>
                        </Grid>
                      </Box>
                    </Box>
                  </Box>
                </GridItem>
                <GridItem
                  borderLeft={{ base: "", md: "", lg: "1px solid #52BBFF" }}
                  paddingLeft={{ base: "", md: "", lg: "0rem" }}
                >
                  <Box padding={"2rem"} marginTop="-4rem" borderRadius={"15px"}>
                    <Box
                      display={"flex"}
                      justifyContent="space-between"
                      mt="4rem"
                    >
                      <Text color={"#141D43"} fontSize="lg" fontWeight={"800"}>
                        <Box
                          as="span"
                          borderRight={"3px solid #2272D5"}
                          height="40px"
                          marginRight={"1rem"}
                        ></Box>
                        Input Details
                      </Text>
                    </Box>
                    <Grid templateColumns="1fr" gap={"1rem"} mt="2rem">
                      <GridItem>
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Select Option{" "}
                          <Text as="span" color="red">
                            *
                          </Text>
                        </Text>
                        <RadioGroup
                          onChange={(value) => setSelectedOptionInput(value)}
                          value={selectedOptionInput}
                          marginTop="10px"
                        >
                          <Stack direction="row">
                            <Radio value="procurement" colorScheme="blue">
                              Select Procurement
                            </Radio>
                            {userData?.role?.includes("GINNER") && (
                              <Radio value="heap" colorScheme="blue">
                                Select Heap
                              </Radio>
                            )}
                          </Stack>
                        </RadioGroup>
                      </GridItem>
                    </Grid>

                    {selectedOptionInput === "procurement" ? (
                      <Grid templateColumns=" 1fr 1fr " gap={"1rem"} mt="2rem">
                        <GridItem>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                          >
                            Input Item &nbsp;
                            <Text as="span" color="red">
                              *
                            </Text>
                          </Text>
                          <Select
                            isDisabled={
                              selectedProductId?.length > 0 ? false : true
                            }
                            _placeholder={{
                              opacity: 1,
                              color: "#141D43",
                              fontSize: "14px",
                            }}
                            value={inputValues.productClassificationId}
                            onChange={(e) => {
                              setInputValues({
                                ...inputValues,
                                productClassificationId: e.target.value,
                              });
                              setCurrentClassificationId(e.target.value);
                              removeGivenHeapIdsFromInventoryOfProcurement();
                              clearSelectedValue();
                            }}
                            color={"#141D43"}
                            border="2px solid  #8fd0fd !important"
                            marginTop="10px"
                            w="100%"
                            bg={"#fff"}
                          >
                            <option hidden="true">Select Input Item</option>
                            {productClassifications?.map(
                              (classification, index) => (
                                <option key={index} value={classification?._id}>
                                  {classification?.name}
                                </option>
                              )
                            )}
                          </Select>
                        </GridItem>
                        <GridItem>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                          >
                            Procurement/TC Number &nbsp;
                            <Text as="span" color="red">
                              *
                            </Text>
                          </Text>
                          <Box key={selectKey}>
                            <Selector.Select
                              style={{ marginTop: "10px" }}
                              disabled={
                                currentClassificationId?.length > 0
                                  ? false
                                  : true
                              }
                              backspaceDelete={false}
                              create={false}
                              searchable={true}
                              options={inventoryOptions}
                              onChange={(values) => {
                                setTopId(values[0].value);
                                getInventoryDetails(values[0].value, false);
                                setCurrentInventoryId(values[0].inventoryId);
                                setTc2Error13(false);
                              }}
                            />
                          </Box>
                          {tc2error13 && (
                            <Box
                              className="error-message"
                              position={"absolute"}
                              fontSize={"14px"}
                              width={"220px"}
                              color={"red"}
                              mt="1rem"
                            >
                              Procurement / TC Number is required
                            </Box>
                          )}
                        </GridItem>
                      </Grid>
                    ) : (
                      <Grid templateColumns=" 1fr 1fr " gap={"1rem"} mt="2rem">
                        <GridItem>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                          >
                            Select Heap &nbsp;
                            <Text as="span" color="red">
                              *
                            </Text>
                          </Text>
                          <Select
                            _placeholder={{
                              opacity: 1,
                              color: "#141D43",
                              fontSize: "14px",
                            }}
                            value={heapId?._id}
                            onChange={(e) => {
                              let h = e.target.value;
                              setTopId(e.target.value);
                              const selectedHeap = heapNumbers?.find(
                                (heap) => heap._id === h
                              );
                              if (h) {
                                let selectedInventoryIds = [];
                                inputs?.forEach((i) => {
                                  if (i?.heapId) {
                                    selectedInventoryIds.push(i?.heapId);
                                  }
                                });

                                if (selectedInventoryIds.includes(h)) {
                                  setHeapError(true);
                                  return;
                                } else {
                                  setHeapId(selectedHeap);
                                  setInputValues({
                                    ...inputValues,
                                    heapId: h,
                                    heapName: selectedHeap?.number,
                                  });
                                }
                              }

                              setHeapError(false);
                            }}
                            color={"#141D43"}
                            border="2px solid  #8fd0fd !important"
                            marginTop="10px"
                            w="100%"
                            bg={"#fff"}
                          >
                            <option hidden="true">Select Heap</option>
                            {heapNumbers?.map((heap, index) => (
                              <option key={index} value={heap?._id}>
                                {heap?.number}
                              </option>
                            ))}
                          </Select>
                          {heapError && (
                            <Box
                              className="error-message"
                              fontSize={"14px"}
                              width={"220px"}
                              color={"red"}
                              m="1rem"
                            >
                              Error: Procurement Input with selected heapId
                              already exists.{" "}
                            </Box>
                          )}
                        </GridItem>
                        {/* <GridItem>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                          >
                            Heap Inventories
                          </Text>
                          <Select
                            _placeholder={{
                              opacity: 1,
                              color: "#141D43",
                              fontSize: "14px",
                            }}
                            color={"#141D43"}
                            border="2px solid  #8fd0fd !important"
                            marginTop="10px"
                            w="100%"
                            bg={"#fff"}
                            onChange={(e) => {
                              // Get the selected value (inventoryId)
                              const selectedInventoryId = e.target.value;
                              console.log(selectedInventoryId, "Id")
                        
                              // Find the selected inventory from inventoryDetails using inventoryId
                              console.log(inventoryDetails, "@inventoryDetails here")
                              const selectedInventory = inventoryDetails?.find(
                                (inventory) => inventory.id === selectedInventoryId
                              );

                              console.log(selectedInventory, "@selectedOnventory Id")
                        
                              if (selectedInventory) {
                                const { _id, inventoryId } = selectedInventory;
                        
                                // Fetch the inventory details based on the selected _id
                                getInventoryDetails(_id, true);
                        
                                // Set the current inventory ID in the state
                                setCurrentInventoryId(inventoryId);
                        
                                // Clear any errors if necessary
                                setTc2Error13(false);
                              }
                            }}
                            // isDisabled={true}
                          >
                            <option hidden="true">See Inventories</option>
                            {inventoryDetails?.map((inventory, index) => (
                              <option key={index} value={inventoryDetails?._id}>{inventory?.id}</option>
                            ))}
                          </Select>
                        </GridItem> */}
                      </Grid>
                    )}
                    {/* {tc2error13 && (
                            <Box
                              className="error-message"
                              position={"absolute"}
                              fontSize={"14px"}
                              width={"220px"}
                              color={"red"}
                              mt="1rem"
                            >
                             Inventory Details are required
                            </Box>
                          )} */}

                    <Grid
                      mt={tc2error13 ? "2rem" : "1rem"}
                      templateColumns={"repeat(1, 1fr)"}
                    >
                      {selectedOptionInput === "procurement" && (
                        <GridItem>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                          >
                            Inventory Details
                          </Text>
                          <Input
                            color={"#141D43"}
                            marginTop="10px"
                            border="2px solid  #8fd0fd !important"
                            w="100%"
                            value={
                              inventoryDetails?.[0]?.id
                                ? inventoryDetails?.[0]?.id
                                : ""
                            }
                            disabled
                            opacity={"1 !important"}
                            bg={"#fff"}
                            fontSize={"14px"}
                            _placeholder={{
                              opacity: 1,
                              color: "#141D43",
                              fontSize: "14px",
                            }}
                          />
                        </GridItem>
                      )}
                    </Grid>

                    <Grid templateColumns="repeat(2, 1fr)" gap="1rem" mt="1rem">
                      <GridItem>
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          {selectedOptionInput === "heap"
                            ? "Total Heap Quantity"
                            : "Available Quantity"}
                        </Text>
                        <Input
                          color={"#141D43"}
                          marginTop="10px"
                          border="2px solid  #8fd0fd !important"
                          w="100%"
                          bg={"#fff"}
                          value={
                            selectedOptionInput === "heap"
                              ? heapId?.totalQuantity
                              : inventoryDetails?.[0]?.remainingQuantity
                          }
                          disabled
                          opacity={"1 !important"}
                          fontSize={"14px"}
                          _placeholder={{
                            opacity: 1,
                            color: "#141D43",
                            fontSize: "14px",
                          }}
                        />
                      </GridItem>
                      <GridItem>
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Consumed Quantity &nbsp;
                          <Text as="span" color="red">
                            *
                          </Text>
                        </Text>
                        <Input
                          color={"#141D43"}
                          marginTop="10px"
                          type="number"
                          border="2px solid  #8fd0fd !important"
                          w="100%"
                          bg={"#fff"}
                          value={
                            inputValues.consumedQuantity
                              ? inputValues.consumedQuantity
                              : ""
                          }
                          _focusVisible={
                            tc2error12 || tc2error3
                              ? {
                                  border: "1px solid red !important",
                                }
                              : { border: "1px solid #8fd0fd " }
                          }
                          onChange={(e) => {
                            setInputValues({
                              ...inputValues,
                              consumedQuantity: e.target.value,
                            });

                            if (selectedOptionInput === "heap") {
                              let valueTemp =
                                parseFloat(inputValues?.consumedQuantity || 0) >
                                heapId?.totalQuantity;

                              if (!valueTemp) {
                                setTc2Error3(false);
                              } else {
                                setTc2Error3(true);
                              }
                            } else if (
                              !(
                                parseFloat(inputValues?.consumedQuantity || 0) >
                                inventoryDetails?.data?.[0]?.remainingQuantity
                              )
                            ) {
                              setTc2Error3(false);
                            }
                            setTc2Error12(false);
                          }}
                          fontSize={"14px"}
                          _placeholder={{
                            opacity: 1,
                            color: "#141D43",
                            fontSize: "14px",
                          }}
                        />
                        {tc2error12 && (
                          <Box
                            className="error-message"
                            position={"absolute"}
                            fontSize={"14px"}
                            width={"220px"}
                            color={"red"}
                            mt="1rem"
                          >
                            Consumed Quantity is required
                          </Box>
                        )}
                        {tc2error3 && (
                          <Box
                            className="error-message"
                            position={"absolute"}
                            fontSize={"14px"}
                            width={"220px"}
                            color={"red"}
                            mt="1rem"
                          >
                            Consumed Quantity can't be greater than available
                            Quantity
                          </Box>
                        )}
                      </GridItem>
                      <GridItem marginTop={"1rem"}>
                        <Box>
                          <Button
                            w="120px"
                            bg="#52BBFF"
                            color={"#fff"}
                            disabled={heapError ? true : ""} //enable later
                            fontWeight="600"
                            _hover={{ bg: "#52BBFF" }}
                            marginRight="6rem"
                            onClick={() => {
                              addInputs(inputValues);
                            }}
                          >
                            Add Input
                          </Button>
                        </Box>
                      </GridItem>
                    </Grid>

                    <Text
                      color={"#141D43"}
                      fontSize="md"
                      fontWeight={"700"}
                      marginTop={"2rem"}
                      fontFamily={"font.roboto"}
                    >
                      {inputs.length > 0
                        ? "List of Input items"
                        : "Added Input items will appear here"}
                    </Text>
                    <Box
                      border={"2px solid #2272D5"}
                      width="10%"
                      marginBottom={"1rem"}
                    ></Box>
                    <Accordion defaultIndex={[0]} marginTop={"2rem"}>
                      {inputs ? (
                        inputs?.map((currentInput, index) => (
                          <AccordionItem>
                            <h2>
                              <AccordionButton>
                                <Box as="span" flex="1" textAlign="left">
                                  <Text
                                    color={"#141D43"}
                                    fontSize="md"
                                    fontWeight={"700"}
                                    fontFamily={"font.roboto"}
                                  >
                                    {currentInput?.productClassificationName ||
                                      currentInput?.heapName}
                                  </Text>
                                </Box>
                                <AccordionIcon />
                              </AccordionButton>
                            </h2>
                            <AccordionPanel pb={4}>
                              <Box marginBottom={"1rem"}>
                                <Box
                                  display={"flex"}
                                  justifyContent="space-between"
                                  mt="1rem"
                                >
                                  <Text
                                    color={"#141D43"}
                                    fontSize="lg"
                                    fontWeight={"800"}
                                  >
                                    <Box
                                      as="span"
                                      borderRight={"3px solid #2272D5"}
                                      height="40px"
                                      marginRight={"1rem"}
                                    ></Box>
                                    Input Details
                                  </Text>
                                </Box>

                                <Grid
                                  mt="1rem"
                                  templateColumns={"repeat(1, 1fr)"}
                                >
                                  <GridItem>
                                    <Text
                                      color={"#141D43"}
                                      fontSize="md"
                                      fontWeight={"700"}
                                      fontFamily={"font.roboto"}
                                    >
                                      Inventory Details
                                    </Text>
                                    <Input
                                      color={"#141D43"}
                                      marginTop="10px"
                                      border="2px solid  #8fd0fd !important"
                                      w="100%"
                                      value={
                                        currentInput?.inventoryName ||
                                        currentInput?.heapName
                                      }
                                      disabled
                                      opacity={"1 !important"}
                                      bg={"#fff"}
                                      fontSize={"14px"}
                                      _placeholder={{
                                        opacity: 1,
                                        color: "#141D43",
                                        fontSize: "14px",
                                      }}
                                    />
                                  </GridItem>
                                </Grid>

                                <Grid
                                  templateColumns="repeat(2, 1fr)"
                                  gap="1rem"
                                  mt="1rem"
                                >
                                  <GridItem>
                                    <Text
                                      color={"#141D43"}
                                      fontSize="md"
                                      fontWeight={"700"}
                                      fontFamily={"font.roboto"}
                                    >
                                      Available Quantity
                                    </Text>
                                    <Input
                                      color={"#141D43"}
                                      marginTop="10px"
                                      border="2px solid  #8fd0fd !important"
                                      w="100%"
                                      bg={"#fff"}
                                      value={currentInput?.availableQuantity}
                                      disabled
                                      opacity={"1 !important"}
                                      fontSize={"14px"}
                                      _placeholder={{
                                        opacity: 1,
                                        color: "#141D43",
                                        fontSize: "14px",
                                      }}
                                    />
                                  </GridItem>
                                  <GridItem>
                                    <Text
                                      color={"#141D43"}
                                      fontSize="md"
                                      fontWeight={"700"}
                                      fontFamily={"font.roboto"}
                                    >
                                      Consumed Quantity
                                    </Text>
                                    <Input
                                      color={"#141D43"}
                                      marginTop="10px"
                                      type="number"
                                      name="consumedQuantity"
                                      border="2px solid  #8fd0fd !important"
                                      w="100%"
                                      bg={"#fff"}
                                      value={currentInput?.consumedQuantity}
                                      onChange={(e) => {
                                        updateInputItem(index, e);
                                        handleConsumedError(
                                          currentInput,
                                          e.target.value
                                        );
                                      }}
                                      fontSize={"14px"}
                                      _placeholder={{
                                        opacity: 1,
                                        color: "#141D43",
                                        fontSize: "14px",
                                      }}
                                    />
                                    {/* {tc2error4 && (
                                      <Box
                                        className="error-message"
                                        position={"absolute"}
                                        fontSize={"14px"}
                                        width={"220px"}
                                        color={"red"}
                                        mt="1rem"
                                      >
                                        Consumed Quantity can't be greater than
                                        available Quantity
                                      </Box>
                                    )} */}
                                  </GridItem>

                                  <GridItem marginTop={"1rem"}>
                                    <Box>
                                      <Button
                                        w="120px"
                                        bg="crimson"
                                        color={"#fff"}
                                        fontWeight="600"
                                        _hover={{ bg: "crimson" }}
                                        marginRight="6rem"
                                        onClick={() =>
                                          removeInputs(
                                            currentInput?.inputId,
                                            currentInput?.inventoryDetails
                                          )
                                        }
                                      >
                                        Remove
                                      </Button>
                                    </Box>
                                  </GridItem>
                                </Grid>
                              </Box>
                            </AccordionPanel>
                          </AccordionItem>
                        ))
                      ) : (
                        <Text
                          fontSize="md"
                          fontWeight={"700"}
                          marginTop={"1rem"}
                          fontFamily={"font.roboto"}
                        >
                          N/A
                        </Text>
                      )}
                    </Accordion>
                  </Box>
                </GridItem>
                <GridItem width={"100%"}>
                  <Text
                    color={"#141D43"}
                    fontSize="md"
                    fontWeight={"700"}
                    fontFamily={"font.roboto"}
                    marginTop={"2rem"}
                    marginBottom={"10px"}
                  >
                    To add more product please click add produt button below
                  </Text>
                  <Button
                    bg={"#52BBFF"}
                    _hover={{ bg: "#3fa7eb" }}
                    color="white"
                    disabled={tc2error1 ? true : ""}
                    cursor={"pointer"}
                    onClick={() => addproducts(productValues)}
                  >
                    Add Products
                  </Button>
                </GridItem>
              </Grid>
            </AccordionPanel>
          </AccordionItem>

          <Box mt={"2rem"}>
            {products.length > 0 ? (
              <Text color={"#141D43"} fontSize="lg" fontWeight={"800"}>
                List of products added
              </Text>
            ) : (
              <Text color={"#141D43"} fontSize="lg" fontWeight={"800"}>
                Added products will appear here
              </Text>
            )}
          </Box>
          <Box
            border={"2px solid #2272D5"}
            width="10%"
            marginBottom={"1rem"}
          ></Box>
          {products?.map((currentProduct, index) => (
            <AccordionItem mt={"1rem"}>
              <Box display={"flex"} justifyContent="space-between">
                <AccordionButton
                  _expanded={{
                    bg: "linear-gradient(90deg, rgba(81,187,255,1) 0%, rgba(81,187,255,1) 15%, rgba(164,206,255,1) 100%)",
                    color: "#fff",
                    borderTopRightRadius: "100px",
                    borderBottomRightRadius: "80px 80px",
                  }}
                >
                  <Text fontSize="lg" fontWeight={"800"}>
                    {currentProduct?.productName
                      ? currentProduct?.productName
                      : "N/A"}{" "}
                    (
                    {currentProduct?.productType
                      ? currentProduct?.productType?.toLowerCase()
                      : "N/A"}
                    ){""}
                    {currentProduct?.process?.map((prc) => (
                      <Text as="span"> {getProcessName(prc)}, </Text>
                    ))}
                  </Text>
                  <AccordionIcon ml={"10px"} />
                </AccordionButton>
              </Box>
              <AccordionPanel pb={4}>
                <Grid
                  templateColumns={{
                    base: "1fr",
                    md: "1fr",
                    lg: "repeat(2, 1fr)",
                  }}
                  gap="1rem"
                >
                  <GridItem>
                    <Box bg="#FFFFFF" padding={"2rem"} borderRadius={"15px"}>
                      <Box paddingLeft={"3rem"}>
                        <Box>
                          <Grid
                            templateColumns={"repeat(2, 1fr)"}
                            gap="1rem"
                            mt="1rem"
                          >
                            <GridItem>
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                Invoice No.
                              </Text>
                              <Input
                                color={"#141D43"}
                                marginTop="10px"
                                border="2px solid  #8fd0fd !important"
                                w="100%"
                                bg={"#fff"}
                                name="invoiceNo"
                                value={currentProduct.invoiceNo}
                                isReadOnly
                                onChange={(e) => {
                                  // updateInput(
                                  //   e.target.value,
                                  //   "invoiceNo",
                                  //   null,
                                  //   index
                                  // );
                                  updateCertifiedInputs(index, "product", e);
                                }}
                                fontSize={"14px"}
                                _placeholder={{
                                  opacity: 1,
                                  color: "#141D43",
                                  fontSize: "14px",
                                }}
                              />
                            </GridItem>
                            <GridItem>
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                Invoice Date
                              </Text>
                              <Input
                                type="date"
                                color={"#141D43"}
                                isReadOnly
                                marginTop="10px"
                                border="2px solid  #8fd0fd !important"
                                w="100%"
                                bg={"#fff"}
                                name="invoiceDate"
                                value={currentProduct.invoiceDate}
                                onChange={(e) => {
                                  // updateInput(
                                  //   e.target.value,
                                  //   "invoiceDate",
                                  //   null,
                                  //   index
                                  // );
                                  updateCertifiedInputs(index, "product", e);
                                }}
                                fontSize={"14px"}
                                _placeholder={{
                                  opacity: 1,
                                  color: "#141D43",
                                  fontSize: "14px",
                                }}
                              />
                            </GridItem>
                          </Grid>
                          <Grid
                            templateColumns={"repeat(2, 1fr)"}
                            gap="1rem"
                            mt="1rem"
                          >
                            <GridItem>
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                Lot No.
                              </Text>
                              <Input
                                color={"#141D43"}
                                marginTop="10px"
                                border="2px solid  #8fd0fd !important"
                                w="100%"
                                isReadOnly
                                bg={"#fff"}
                                name="lotNo"
                                value={currentProduct.lotNo}
                                onChange={(e) => {
                                  // updateInput(
                                  //   e.target.value,
                                  //   "invoiceNo",
                                  //   null,
                                  //   index
                                  // );
                                  updateCertifiedInputs(index, "product", e);
                                }}
                                fontSize={"14px"}
                                _placeholder={{
                                  opacity: 1,
                                  color: "#141D43",
                                  fontSize: "14px",
                                }}
                              />
                            </GridItem>
                            <GridItem>
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                Packed In
                              </Text>
                              <Input
                                type="string"
                                color={"#141D43"}
                                marginTop="10px"
                                border="2px solid  #8fd0fd !important"
                                w="100%"
                                isReadOnly
                                bg={"#fff"}
                                name="packedIn"
                                value={currentProduct.packedIn}
                                onChange={(e) => {
                                  // updateInput(
                                  //   e.target.value,
                                  //   "invoiceDate",
                                  //   null,
                                  //   index
                                  // );
                                  updateCertifiedInputs(index, "product", e);
                                }}
                                fontSize={"14px"}
                                _placeholder={{
                                  opacity: 1,
                                  color: "#141D43",
                                  fontSize: "14px",
                                }}
                              />
                            </GridItem>
                          </Grid>
                          <Grid
                            templateColumns="repeat(2,1fr)"
                            gap="1rem"
                            mt={"1rem"}
                          >
                            <GridItem>
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                Net Weight (kg)
                              </Text>
                              <Input
                                color={"#141D43"}
                                marginTop="10px"
                                type="number"
                                border="2px solid  #8fd0fd !important"
                                w="100%"
                                isReadOnly
                                bg={"#fff"}
                                name="netWeight"
                                fontSize={"14px"}
                                value={currentProduct.netWeight}
                                onChange={(e) => {
                                  // updateInput(
                                  //   e.target.value,
                                  //   "netWeight",
                                  //   null,
                                  //   index
                                  // );
                                  updateCertifiedInputs(index, "product", e);
                                  recalculateUpdatedInputs(index, e);
                                }}
                                _placeholder={{
                                  opacity: 1,
                                  color: "#141D43",
                                  fontSize: "14px",
                                }}
                              />
                            </GridItem>
                            <GridItem>
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                Gross Weight (kg)
                              </Text>
                              <Input
                                color={"#141D43"}
                                marginTop="10px"
                                type="number"
                                name="grossWeight"
                                isReadOnly
                                border="2px solid  #8fd0fd !important"
                                w="100%"
                                bg={"#fff"}
                                value={currentProduct.grossWeight}
                                onChange={(e) => {
                                  updateCertifiedInputs(index, "product", e);
                                }}
                                fontSize={"14px"}
                                _placeholder={{
                                  opacity: 1,
                                  color: "#141D43",
                                  fontSize: "14px",
                                }}
                              />
                            </GridItem>
                          </Grid>
                          <Grid
                            templateColumns="repeat(2, 1fr)"
                            gap={"1rem"}
                            mt="1rem"
                          >
                            <GridItem>
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                Product Category
                              </Text>
                              <Text marginTop={"10px"}>
                                {currentProduct.productCategory
                                  ? currentProduct.productCategory
                                  : "N/A"}
                              </Text>
                            </GridItem>
                            <GridItem>
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                Product Classification
                              </Text>
                              <Text marginTop={"10px"}>
                                {currentProduct.productClassification
                                  ? currentProduct.productClassification
                                  : "N/A"}
                              </Text>
                            </GridItem>
                          </Grid>

                          <Grid
                            templateColumns="repeat(1,1fr)"
                            mt="1rem"
                            gap={"3rem"}
                          >
                            <GridItem>
                              <Grid templateColumns="repeat(2,2fr)" gap="1rem">
                                <GridItem>
                                  <Text
                                    color={"#141D43"}
                                    fontSize="md"
                                    fontWeight={"700"}
                                    fontFamily={"font.roboto"}
                                  >
                                    Certified Material
                                  </Text>
                                  <Text marginTop={"10px"}>
                                    {currentProduct.certifiedMaterialName
                                      ? currentProduct.certifiedMaterialName
                                      : "N/A"}
                                  </Text>
                                </GridItem>

                                <GridItem>
                                  <Box
                                    display={"flex"}
                                    justifyContent={"center"}
                                    alignItems={"center"}
                                  >
                                    <Box>
                                      <Text
                                        color={"#141D43"}
                                        fontSize="sm"
                                        fontWeight={"700"}
                                        fontFamily={"font.roboto"}
                                      >
                                        Percentage
                                      </Text>
                                      <Input
                                        color={"#141D43"}
                                        marginTop="10px"
                                        type="number"
                                        border="2px solid  #8fd0fd !important"
                                        w="50%"
                                        isReadOnly
                                        bg={"#fff"}
                                        name="percentage"
                                        value={
                                          currentProduct?.certifiedMaterial
                                            ?.percentage
                                        }
                                        // onChange={(e) => {
                                        //   // updateInput(
                                        //   //   e.target.value,
                                        //   //   "certifiedMaterial",
                                        //   //   "percentage",
                                        //   //   index
                                        //   // );
                                        //   updateCertifiedInputs(
                                        //     index,
                                        //     "composition",
                                        //     e
                                        //   );
                                        //   if (
                                        //     parseFloat(e.target.value) >
                                        //     currentProduct?.certifiedMaterial
                                        //       ?.maxVal
                                        //   ) {
                                        //     setTc2Error7(true);
                                        //   } else {
                                        //     setTc2Error7(false);
                                        //   }
                                        // }}
                                        fontSize={"14px"}
                                        _placeholder={{
                                          opacity: 1,
                                          color: "#141D43",
                                          fontSize: "14px",
                                        }}
                                      />
                                      {tc2error7 && (
                                        <Box
                                          className="error-message"
                                          position={"absolute"}
                                          fontSize={"14px"}
                                          width={"220px"}
                                          color={"red"}
                                          mt="1rem"
                                        >
                                          Percentage can't be greater certified
                                          material max range
                                        </Box>
                                      )}
                                    </Box>
                                    <Box>
                                      <Text
                                        color={"#141D43"}
                                        fontSize="sm"
                                        fontWeight={"700"}
                                        fontFamily={"font.roboto"}
                                      >
                                        Loss Percent
                                      </Text>
                                      <Input
                                        color={"#141D43"}
                                        type="number"
                                        name="lossPercent"
                                        marginTop="10px"
                                        border="2px solid  #8fd0fd !important"
                                        w="50%"
                                        isReadOnly
                                        bg={"#fff"}
                                        value={
                                          currentProduct.certifiedMaterial
                                            .lossPercent
                                        }
                                        onChange={(e) => {
                                          // updateInput(
                                          //   e.target.value,
                                          //   "certifiedMaterial",
                                          //   "lossPercent",
                                          //   index
                                          // );
                                          updateCertifiedInputs(
                                            index,
                                            "composition",
                                            e
                                          );
                                        }}
                                        fontSize={"14px"}
                                        _placeholder={{
                                          opacity: 1,
                                          color: "#141D43",
                                          fontSize: "14px",
                                        }}
                                      />
                                    </Box>
                                  </Box>
                                </GridItem>
                              </Grid>

                              <Grid
                                templateColumns="repeat(2,1fr)"
                                gap="1rem"
                                mt={tc2error7 ? "4rem" : "1rem"}
                              >
                                <GridItem>
                                  <Text
                                    color={"#141D43"}
                                    fontSize="md"
                                    fontWeight={"700"}
                                    fontFamily={"font.roboto"}
                                  >
                                    Consumption
                                  </Text>
                                  <Input
                                    color={"#141D43"}
                                    marginTop="10px"
                                    border="2px solid  #8fd0fd !important"
                                    w="100%"
                                    bg={"#fff"}
                                    fontSize={"14px"}
                                    value={
                                      currentProduct.certifiedMaterial
                                        .consumption
                                    }
                                    disabled
                                    opacity={"1 !important"}
                                    onChange={(e) => {
                                      updateInput(
                                        e.target.value,
                                        "certifiedMaterial",
                                        "consumption",
                                        index
                                      );
                                    }}
                                    _placeholder={{
                                      opacity: 1,
                                      color: "#141D43",
                                      fontSize: "14px",
                                    }}
                                  />
                                </GridItem>
                                <GridItem>
                                  <Text
                                    color={"#141D43"}
                                    fontSize="md"
                                    fontWeight={"700"}
                                    fontFamily={"font.roboto"}
                                  >
                                    Certified Weight
                                  </Text>
                                  <Input
                                    color={"#141D43"}
                                    marginTop="10px"
                                    border="2px solid  #8fd0fd !important"
                                    w="100%"
                                    bg={"#fff"}
                                    value={
                                      currentProduct.certifiedMaterial
                                        .certifiedWeight
                                    }
                                    disabled
                                    opacity={"1 !important"}
                                    onChange={(e) => {
                                      setProductValues({
                                        ...productValues,
                                        certifiedMaterialWeight: e.target.value,
                                      });
                                    }}
                                    fontSize={"14px"}
                                    _placeholder={{
                                      opacity: 1,
                                      color: "#141D43",
                                      fontSize: "14px",
                                    }}
                                  />
                                </GridItem>
                              </Grid>
                              <Box
                                marginTop="1rem"
                                border={"1px solid #52BBFF"}
                                width="100%"
                                marginBottom={"1rem"}
                              ></Box>
                              {currentProduct?.nonCertifiedMaterials?.length >
                              0 ? (
                                <>
                                  {" "}
                                  <Text
                                    color={"#141D43"}
                                    fontSize="md"
                                    fontWeight={"700"}
                                    marginTop={"1rem"}
                                    fontFamily={"font.roboto"}
                                  >
                                    Non Certified Materials
                                  </Text>
                                  <Box
                                    border={"2px solid #2272D5"}
                                    width="10%"
                                    marginBottom={"1rem"}
                                  ></Box>{" "}
                                </>
                              ) : (
                                ""
                              )}
                              <Accordion defaultIndex={[0]}>
                                {currentProduct?.nonCertifiedMaterials?.map(
                                  (data, idx) => (
                                    <AccordionItem>
                                      <h2>
                                        <AccordionButton>
                                          <Box
                                            as="span"
                                            flex="1"
                                            textAlign="left"
                                          >
                                            <Text
                                              color={"#141D43"}
                                              fontSize="md"
                                              fontWeight={"700"}
                                              fontFamily={"font.roboto"}
                                            >
                                              {data?.commodityName
                                                ? data?.commodityName
                                                : "N/A"}
                                            </Text>
                                          </Box>
                                          <AccordionIcon />
                                        </AccordionButton>
                                      </h2>
                                      <AccordionPanel pb={4}>
                                        <Box marginBottom={"1rem"}>
                                          <Grid
                                            templateColumns="repeat(2,2fr)"
                                            gap="1rem"
                                          >
                                            <GridItem>
                                              <Box>
                                                <Text
                                                  color={"#141D43"}
                                                  fontSize="md"
                                                  fontWeight={"700"}
                                                  fontFamily={"font.roboto"}
                                                >
                                                  Percentage
                                                </Text>
                                                <Input
                                                  color={"#141D43"}
                                                  marginTop="10px"
                                                  border="2px solid  #8fd0fd !important"
                                                  w="100%"
                                                  type="number"
                                                  name="percentage"
                                                  bg={"#fff"}
                                                  value={data?.percentage}
                                                  onChange={(e) =>
                                                    updateNcInput(index, idx, e)
                                                  }
                                                  fontSize={"14px"}
                                                  _placeholder={{
                                                    opacity: 1,
                                                    color: "#141D43",
                                                    fontSize: "14px",
                                                  }}
                                                />
                                              </Box>
                                            </GridItem>
                                            <GridItem>
                                              <Box>
                                                <Text
                                                  color={"#141D43"}
                                                  fontSize="md"
                                                  fontWeight={"700"}
                                                  fontFamily={"font.roboto"}
                                                >
                                                  Loss Percent
                                                </Text>
                                                <Input
                                                  color={"#141D43"}
                                                  marginTop="10px"
                                                  border="2px solid  #8fd0fd !important"
                                                  w="100%"
                                                  name="lossPercent"
                                                  bg={"#fff"}
                                                  value={data?.lossPercent}
                                                  onChange={(e) =>
                                                    updateNcInput(index, idx, e)
                                                  }
                                                  fontSize={"14px"}
                                                  _placeholder={{
                                                    opacity: 1,
                                                    color: "#141D43",
                                                    fontSize: "14px",
                                                  }}
                                                />
                                              </Box>
                                            </GridItem>
                                          </Grid>
                                          <Grid
                                            templateColumns="repeat(2,1fr)"
                                            gap="1rem"
                                            mt={"1rem"}
                                          >
                                            <GridItem>
                                              <Text
                                                color={"#141D43"}
                                                fontSize="md"
                                                fontWeight={"700"}
                                                fontFamily={"font.roboto"}
                                              >
                                                Consumption
                                              </Text>
                                              <Input
                                                color={"#141D43"}
                                                marginTop="10px"
                                                border="2px solid  #8fd0fd !important"
                                                w="100%"
                                                bg={"#fff"}
                                                value={data?.consumption}
                                                disabled
                                                opacity={"1 !important"}
                                                fontSize={"14px"}
                                                _placeholder={{
                                                  opacity: 1,
                                                  color: "#141D43",
                                                  fontSize: "14px",
                                                }}
                                              />
                                            </GridItem>
                                            <GridItem>
                                              <Text
                                                color={"#141D43"}
                                                fontSize="md"
                                                fontWeight={"700"}
                                                fontFamily={"font.roboto"}
                                              >
                                                Certified Weight
                                              </Text>
                                              <Input
                                                color={"#141D43"}
                                                marginTop="10px"
                                                border="2px solid  #8fd0fd !important"
                                                w="100%"
                                                bg={"#fff"}
                                                value={data?.nonCertifiedWeight}
                                                disabled
                                                opacity={"1 !important"}
                                                fontSize={"14px"}
                                                _placeholder={{
                                                  opacity: 1,
                                                  color: "#141D43",
                                                  fontSize: "14px",
                                                }}
                                              />
                                            </GridItem>
                                          </Grid>
                                        </Box>
                                      </AccordionPanel>
                                    </AccordionItem>
                                  )
                                )}
                              </Accordion>
                            </GridItem>
                          </Grid>
                          <Grid templateColumns="repeat(1, 1fr)" mt="1rem">
                            <GridItem>
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                Product Information
                              </Text>
                              <Textarea
                                type="text"
                                color={"#141D43"}
                                marginTop="1rem"
                                bg={"#fff"}
                                h={"100%"}
                                w={"100%"}
                                border="2px solid  #8fd0fd !important"
                                value={currentProduct.productInformation}
                                onChange={(e) => {
                                  updateInput(
                                    e.target.value,
                                    "productInformation",
                                    null,
                                    index
                                  );
                                }}
                                fontSize={"14px"}
                                _placeholder={{
                                  opacity: 1,
                                  color: " #464C64",
                                  fontSize: "14px",
                                }}
                              />
                            </GridItem>
                          </Grid>
                        </Box>
                      </Box>
                    </Box>
                  </GridItem>
                  <GridItem
                    borderLeft={{ base: "", md: "", lg: "1px solid #52BBFF" }}
                    paddingLeft={{ base: "", md: "", lg: "0rem" }}
                  >
                    <Box
                      padding={"2rem"}
                      marginTop="-4rem"
                      borderRadius={"15px"}
                    >
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        marginTop={"4rem"}
                        fontFamily={"font.roboto"}
                      >
                        List of Input Items
                      </Text>
                      <Box
                        border={"2px solid #2272D5"}
                        width="10%"
                        marginBottom={"1rem"}
                      ></Box>
                      <Accordion defaultIndex={[0]} marginTop={"2rem"}>
                        {currentProduct ? (
                          // products?.map((product, index) =>
                          currentProduct?.inputs?.map((currentInput, index) =>
                            currentInput ? (
                              <Card
                                padding={"2rem"}
                                boxShadow={
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                                }
                              >
                                <AccordionItem>
                                  <h2>
                                    <AccordionButton>
                                      <Box as="span" flex="1" textAlign="left">
                                        <Text
                                          color={"#141D43"}
                                          fontSize="md"
                                          fontWeight={"700"}
                                          fontFamily={"font.roboto"}
                                        >
                                          {currentInput?.productClassificationName ||
                                            currentInput?.heapName}
                                        </Text>
                                      </Box>
                                      <AccordionIcon />
                                    </AccordionButton>
                                  </h2>
                                  <AccordionPanel pb={4}>
                                    <Box marginBottom={"1rem"}>
                                      <Box
                                        display={"flex"}
                                        justifyContent="space-between"
                                        mt="1rem"
                                      >
                                        <Text
                                          color={"#141D43"}
                                          fontSize="lg"
                                          fontWeight={"800"}
                                        >
                                          <Box
                                            as="span"
                                            borderRight={"3px solid #2272D5"}
                                            height="40px"
                                            marginRight={"1rem"}
                                          ></Box>
                                          Input Details
                                        </Text>
                                      </Box>

                                      <Grid
                                        mt="1rem"
                                        templateColumns={"repeat(1, 1fr)"}
                                      >
                                        <GridItem>
                                          <Text
                                            color={"#141D43"}
                                            fontSize="md"
                                            fontWeight={"700"}
                                            fontFamily={"font.roboto"}
                                          >
                                            {selectedOptionInput === "heap"
                                              ? "Heap details"
                                              : "Inventory Details"}
                                          </Text>
                                          <Text>
                                            {currentInput?.inventoryName ||
                                              currentInput?.heapName}
                                          </Text>
                                        </GridItem>
                                      </Grid>

                                      <Grid
                                        templateColumns="repeat(2, 1fr)"
                                        gap="1rem"
                                        mt="1rem"
                                      >
                                        <GridItem>
                                          <Text
                                            color={"#141D43"}
                                            fontSize="md"
                                            fontWeight={"700"}
                                            fontFamily={"font.roboto"}
                                          >
                                            {selectedOptionInput === "heap"
                                              ? "Total Heap Quantity"
                                              : "Available Quantity"}
                                          </Text>
                                          <Text>
                                            {currentInput?.availableQuantity}
                                          </Text>
                                        </GridItem>
                                        <GridItem>
                                          <Text
                                            color={"#141D43"}
                                            fontSize="md"
                                            fontWeight={"700"}
                                            fontFamily={"font.roboto"}
                                          >
                                            Consumed Quantity
                                          </Text>
                                          <Text>
                                            {currentInput?.consumedQuantity}
                                          </Text>
                                        </GridItem>
                                      </Grid>
                                    </Box>
                                  </AccordionPanel>
                                </AccordionItem>
                              </Card>
                            ) : (
                              "NO inputs added"
                            )
                          )
                        ) : (
                          <Text
                            fontSize="md"
                            fontWeight={"700"}
                            marginTop={"1rem"}
                            fontFamily={"font.roboto"}
                          >
                            N/A
                          </Text>
                        )}
                      </Accordion>
                    </Box>
                  </GridItem>
                  <GridItem marginTop={"2rem"}>
                    <Button
                      bg={"crimson"}
                      _hover={{ bg: "crimson" }}
                      color="white"
                      cursor={"pointer"}
                      marginLeft={"5rem"}
                      onClick={() => removeProducts(currentProduct.id)}
                    >
                      Remove Product
                    </Button>
                  </GridItem>
                </Grid>
              </AccordionPanel>
            </AccordionItem>
          ))}
        </Accordion>
      </Box>
    </>
  );
}

export default TcFormCards2;
